<template>
<div>
	<h3>Política AIMS</h3>
  <SimpleCrud
    :headers="headers"
    :name="rq_name"
    :scheme="scheme"
    :canDetail="false"
    :canAdd="false"
    :canDelete="false">
    <!-- <template v-slot:creation_date="{ value }">
      <td>{{formalDateFormat(value)}}</td>
    </template> -->
    <!-- <template slot="crud-title">Política AIMS</template> -->
		<template slot="write-title">Editar</template>
    <template slot-scope="{ selectedItem }" slot="write">
				<in-text v-model="selectedItem.name" label="Nombre"/>
				<!-- <br>
				<in-calendar :date.sync="selectedItem.update_date" label="Fecha de Actualización" :required="true"/> -->
				<br>
				<in-calendar :date.sync="selectedItem.due_date" label="Fecha de Término" :required="true"/>
				<br>
				<in-file :value.sync="selectedItem.file" label="Archivo"/>
				<br>
        <br>
				<in-text v-model="selectedItem.bhp_url" label="Link Documento"/>
				<br>
				<fs1 tag="p" style="color:darkred" v-if="selectedItem.bhp_url">La vinculación de documentos por medio de un link ignorará el archivo cargado en plataforma.</fs1>
    </template>
  </SimpleCrud>
</div>
</template>

<script>
export default {
  data() {
    return {
      rq_name:'aims_policy',
			scheme:{
				link:{ type:'file'},
				file:{ type:'file'},
			},
      headers:[
				{ text: '', value: 'actions' },
				{ text: 'Nombre', value: 'name' },
				/* { text: 'Fecha de Actualización', value: 'update_date' }, */
				{ text: 'Fecha de vencimiento', value: 'due_date' },
				{ text: 'Archivo', value: 'link' },
      ],
    };
  },
};
</script>
